import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import PopupLoader from './utils/PopupLoader';

const restricciones_desactivadas = process.env.REACT_APP_RESTRICCIONES_DESACTIVADAS === "true";

function PaginaUrl_Whatsapp() {

    const navigate = useNavigate()
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        setLoading(true);

        localStorage.setItem('UrlWhatsapp', "true");
        setLoading(false);

        navigate("/", { replace: true });
    }, [])

    return (
        <>
            <PopupLoader loading={loading} />
        </>
    )

}

export default PaginaUrl_Whatsapp;